import bezier from "../../../utils/easings/easing-bezier";
import spring from "../../../utils/easings/easing-spring";
import getValuesArray from "../../../utils/get-values-array";
import { G_EasingFunctionDefaults } from "../../../utils/globals/option-function-defaults";

/**
 * Process option and parameters function
 * @param {StorageProps} storage
 */
const processValueFunctions = (storage) => {
  const functions = /** @type {StorageFunctionProps} */ (storage.get("functions"));

  for (const [fn, data] of functions) {
    if (fn === "easing") {
      if (data.get("is-fn")) {
        const name = data.get("name");
        const values = /** @type {Array<PropertyValueProps>} */ (data.get("values"));

        if (name === "spring") {
          const result = /** @type {[Number, Number]} */ (getValuesArray(values));
          data.set("value", spring(...result));
        } else {
          const result = /** @type {[Number, Number, Number, Number]} */ (getValuesArray(values));
          data.set("value", bezier(...result));
        }
      } else {
        const name = /** @type {EasingProps} */ (data.get("output"));
        data.set("value", G_EasingFunctionDefaults.get(name));
      }
    }
  }
};

export default processValueFunctions;
